import { ApiSet, BaseResponse, IndexApiSet, useDeleteApi, useIndexApi, usePutApi } from 'utils/network/api_hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { TranscriptionHistory, TranscriptionHistoryForm, TranscriptionHistorySearchForm } from 'entities/transcription_history'
import { Form, useEffectSkipFirst } from 'utils/hooks'

type TranscriptionHistoriesResponse = PagingResponse & {
    results: TranscriptionHistory[]
}

export function useFetchTranscriptionHistoriesApi(searchForm: Form<TranscriptionHistorySearchForm>): IndexApiSet<TranscriptionHistoriesResponse> & {
    execute: () => void
} {
    const apiPath = 'transcription_histories/'
    const api = useIndexApi<TranscriptionHistoriesResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
        initialState: { page: searchForm.object.page || 1, perPage: searchForm.object.perPage || 50 },
    })

    const execute = (): void => {
        api.execute(apiPath, { params: searchForm.object })
    }

    useEffectSkipFirst(() => {
        searchForm.update((f) => {
            if (api.pageSet.page) f.page = api.pageSet.page
            if (api.pageSet.perPage) f.perPage = api.pageSet.perPage
        })
    }, [api.pageSet.page, api.pageSet.perPage])

    useEffectSkipFirst(() => {
        execute()
    }, [searchForm.object])

    return { ...api, execute: execute }
}

type TranscriptionHistoryResponse = BaseResponse & TranscriptionHistory

export function useDeleteTranscriptionHistoryApi(): ApiSet<TranscriptionHistoryResponse> & {
    execute: (id: number) => void
} {
    const api = useDeleteApi<TranscriptionHistoryResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (id: number): void => {
        const apiPath = `transcription_histories/${id}/`
        api.execute(apiPath)
    }

    return { ...api, execute: execute }
}

export function usePutTranscriptionHistoryApi(): ApiSet<BaseResponse> & { execute: (form: Form<TranscriptionHistoryForm>) => void } {
    const apiSet = usePutApi<BaseResponse, TranscriptionHistoryForm>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<TranscriptionHistoryForm>) => {
        const apiPath = `transcription_histories/${form.object.id}/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}